// extracted by mini-css-extract-plugin
export default {"mt":"favouriteproductpagelikerequest_mt__5BTjQ","pagination":"favouriteproductpagelikerequest_pagination__M6AXi"};